import { z } from 'zod';
import { encodeBody } from '../http/encode.js';
import { binCreateSchema, binSchema, warehouseCountSchema, warehouseCreateSchema, warehousePatchSchema, warehouseSchema, zoneCreateSchema, zoneSchema, } from '../schemas/locations.js';
const warehouseListSchema = z.array(warehouseSchema);
const zoneListSchema = z.array(zoneSchema);
const binListSchema = z.array(binSchema);
export class LocationsApi {
    transport;
    constructor(transport) {
        this.transport = transport;
    }
    listWarehouses(signal) {
        return this.transport.request({
            method: 'GET',
            path: '/v1/warehouses',
            schema: warehouseListSchema,
            signal,
        });
    }
    getWarehouse(warehouseId, signal) {
        return this.transport.request({
            method: 'GET',
            path: `/v1/warehouses/${encodeURIComponent(warehouseId)}`,
            schema: warehouseSchema,
            signal,
        });
    }
    countWarehouses(signal) {
        return this.transport
            .request({
            method: 'GET',
            path: '/v1/warehouses/count',
            schema: warehouseCountSchema,
            signal,
        })
            .then((r) => r.count);
    }
    /**
     * The FIRST warehouse is on every plan; the SECOND is where `multi_warehouse` is
     * enforced, and a 403 arrives from here rather than from the router. An essential-tier
     * tenant with nowhere to receive stock would have an unusable ledger, which is why the
     * gate is asymmetric — a skin should present the upgrade prompt at the second warehouse,
     * not by hiding the button entirely.
     */
    createWarehouse(payload, operation, signal) {
        return this.transport.request({
            method: 'POST',
            path: '/v1/warehouses',
            body: encodeBody(warehouseCreateSchema, payload, 'createWarehouse'),
            operation,
            schema: warehouseSchema,
            signal,
        });
    }
    updateWarehouse(warehouseId, patch, operation, signal) {
        return this.transport.request({
            method: 'PATCH',
            path: `/v1/warehouses/${encodeURIComponent(warehouseId)}`,
            body: encodeBody(warehousePatchSchema, patch, 'updateWarehouse'),
            operation,
            schema: warehouseSchema,
            signal,
        });
    }
    /** Zones and bins are gated on `multi_warehouse` at the router. */
    listZones(warehouseId, signal) {
        return this.transport.request({
            method: 'GET',
            path: `/v1/warehouses/${encodeURIComponent(warehouseId)}/zones`,
            schema: zoneListSchema,
            signal,
        });
    }
    createZone(payload, operation, signal) {
        return this.transport.request({
            method: 'POST',
            path: '/v1/zones',
            body: encodeBody(zoneCreateSchema, payload, 'createZone'),
            operation,
            schema: zoneSchema,
            signal,
        });
    }
    listBins(zoneId, signal) {
        return this.transport.request({
            method: 'GET',
            path: `/v1/zones/${encodeURIComponent(zoneId)}/bins`,
            schema: binListSchema,
            signal,
        });
    }
    createBin(payload, operation, signal) {
        return this.transport.request({
            method: 'POST',
            path: '/v1/bins',
            body: encodeBody(binCreateSchema, payload, 'createBin'),
            operation,
            schema: binSchema,
            signal,
        });
    }
}
//# sourceMappingURL=locations.js.map